import { Button, Container, Stack } from '@mui/material'
import React from 'react'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import ActivityWeightsTable from '../activityWeights/ActivityWeightsTable'
import IncentiveProductDialog from './IncentiveProductDialog'
import IncentiveProductTable from './IncentiveProductTable'
import type {
  ActivityWeight,
  IncentiveSalesTarget,
  MonthlySalesIncentive,
  SalesIncentiveProduct,
} from './incentiveProductTypes'
import IncentiveSalesCorrectionFactors from './IncentiveSalesCorrectionFactors'
import { incentiveSalesCorrectionFactorQuery } from './incentiveSalesCorrectionFactorsQueries'
import { IncentiveSalesCorrectionFactorResponse } from './incentiveSalesCorrectionFactorTypes'
import { IncentiveSalesTargets } from './IncentiveSalesTargets'

type Props = {
  incentiveSalesProducts: SalesIncentiveProduct[]
  incentiveSalesTarget: IncentiveSalesTarget
  incentiveSalesTargetNextYear: IncentiveSalesTarget
  incentiveSalesWeights: ActivityWeight[]
  incentiveSalesLastYear?: MonthlySalesIncentive[]
  incentiveSalesCurrentYear?: MonthlySalesIncentive[]
  variables: { stationId?: string; date?: Date; nextYearDate?: Date }
  user?: User
}

type State = {
  isDialogOpen: boolean
  data: SalesIncentiveProduct | null | undefined
}

interface QueryResponse {
  incentiveSalesCorrectionFactors: IncentiveSalesCorrectionFactorResponse[]
}

@withUser
class IncentiveProductPage extends React.PureComponent<Props, State> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: SalesIncentiveProduct) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const {
      incentiveSalesTargetNextYear,
      incentiveSalesTarget,
      incentiveSalesWeights,
      incentiveSalesProducts,
      incentiveSalesCurrentYear,
      incentiveSalesLastYear,
      variables: { stationId, date, nextYearDate },
    } = this.props
    const { isDialogOpen, data } = this.state
    const isDecember = new Date().getMonth() === 11
    return (
      <Container disableGutters sx={{ width: '1200px' }}>
        {stationId && (
          <Stack direction='column' spacing={2} mb={2}>
            <IncentiveSalesTargets
              user={this.props.user}
              date={date}
              stationId={stationId}
              incentiveSalesTargetData={incentiveSalesTarget}
              lastYearOutcomeData={incentiveSalesLastYear}
            />
            {isDecember && (
              <IncentiveSalesTargets
                user={this.props.user}
                date={nextYearDate}
                stationId={stationId}
                incentiveSalesTargetData={incentiveSalesTargetNextYear}
                lastYearOutcomeData={incentiveSalesCurrentYear}
              />
            )}
          </Stack>
        )}
        <IncentiveProductTable data={incentiveSalesProducts} variables={{ stationId, date }} onEdit={this.onEdit} />
        {!stationId && (
          <Query<QueryResponse, {}> query={incentiveSalesCorrectionFactorQuery} fetchPolicy='network-only'>
            {({ data, loading }) => {
              return (
                <Loader loading={loading}>
                  <IncentiveSalesCorrectionFactors correctionFactors={data.incentiveSalesCorrectionFactors} />
                </Loader>
              )
            }}
          </Query>
        )}
        <Stack direction='row' justifyContent='flex-end'>
          <Button onClick={this.openDialog} variant='contained' color='primary'>
            {i18n.t('buttons.create')}
          </Button>
        </Stack>
        {stationId && (
          <ActivityWeightsTable stationId={stationId} data={incentiveSalesWeights} type='incentive_sales' />
        )}
        <IncentiveProductDialog
          data={data}
          stationId={stationId}
          date={date}
          isOpen={isDialogOpen}
          onClose={this.closeDialog}
        />
      </Container>
    )
  }
}

export default IncentiveProductPage
